// extracted by mini-css-extract-plugin
export default {"c-modal":"modal_c-modal__71bvE","backdrop":"modal_backdrop__7EsN2","modal-content":"modal_modal-content__M-LlF"};